import { render, staticRenderFns } from "./candidateList.vue?vue&type=template&id=28d3b59c&scoped=true"
import script from "./candidateList.vue?vue&type=script&lang=js"
export * from "./candidateList.vue?vue&type=script&lang=js"
import style0 from "./candidateList.vue?vue&type=style&index=0&id=28d3b59c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d3b59c",
  null
  
)

export default component.exports